import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useCollect, useRequest } from 'hooks';

import { MATERIAL_TYPES } from 'utils/Constants';

import { Title } from 'components/Misc/Typography';
import { Form, Input, Select, Type, Button } from 'components/Misc/Form';

// import Validator from 'utils/Validator';

import { useAppStore } from 'store/useAppStore';
import { useMaterialCreateStore } from 'store/material/useMaterialCreateStore';

const Create = () => {
	// Use router's history
	const history = useHistory();

	// User app's store
	const role = useAppStore(state => state.user.role);

	// Use material's creation store
	const [material, onChange, onReset] = useMaterialCreateStore(state => [
		state.material,
		state.onChange,
		state.onReset
	]);

	// Store subject request parameters
	const subjectParameters = useMemo(() => (['admin', 'employee'].includes(role) ? {} : {
		condition: 'related'
	}), [role]);

	// Store course request parameters
	const courseParameters = useMemo(() => (['admin', 'employee'].includes(role) ? {
		subjectId: material.subjectId
	} : {
		condition: 'related',
		subjectId: material.subjectId
	}), [role, material.subjectId]);

	// Store collected subjects
	const [[subjects], collectSubjects] = useCollect('subjects', subjectParameters);

	// Store collected courses
	const [[courses], collectCourses] = useCollect('courses', courseParameters);

	// Store request
	const [[progress], request] = useRequest('post', 'materials');

	// Collect subjects on mount
	useEffect(() => {
		(async () => await collectSubjects())();
	}, [collectSubjects]);

	// Collect courses on subject selection
	useEffect(() => {
		if (courseParameters.subjectId) (async () => await collectCourses())();
	}, [courseParameters, collectCourses]);

	// Handle store cleanup
	useEffect(() => {
		return () => onReset();
	}, []);

	// Handle submit event
	const onSubmit = async (event) => {
		event.preventDefault();

		// Try to create material
		const [success, error] = await request(material);

		// Redirect on successful creation
		if (success) return history.push('/materials');

		// TODO: Handle errors
		if (error) console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="mx-auto p-4 max-w-screen-md grid md:grid-cols-2 gap-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Pamatinformācija"
				className="md:col-span-2 text-xl"
			/>

			<Input
				type="text"
				name="title"
				label="Nosaukums"
				value={material.title}
				onChange={onChange}
			/>

			<Input
				type="text"
				name="titlePublic"
				label="Publiskais nosaukums"
				value={material.titlePublic}
				onChange={onChange}
			/>

			<Select
				name="subjectId"
				label="Mācību kurss"
				placeholder=" "
				value={material.subjectId}
				onChange={onChange}
				options={subjects?.map(subject => ({
					value: subject.id,
					name: subject.title
				}))}
			/>

			<Select
				name="courseId"
				label="Mācību modulis"
				placeholder=" "
				disabled={!courses?.length}
				value={material.courseId}
				onChange={onChange}
				options={courses?.map(course => ({
					value: course.id,
					name: course.title
				}))}
			/>

			<Title
				title="Tips"
				className="col-span-2 text-xl"
			/>

			<Type
				name="type"
				value={material.type}
				onChange={onChange}
				options={MATERIAL_TYPES}
				className="col-span-2"
			/>

			<div className="md:col-span-2 flex justify-end">
				<Button
					submit
					icon="done"
					value="Izveidot"
					theme="success"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Create;